// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"112":"bce4c4b0","152":"a3791e51","281":"1571574c","959":"bf294ac5","986":"b32b7474"}[chunkId] + ".chunk.css";
};